import { render, staticRenderFns } from "./importEleve.vue?vue&type=template&id=6b64ec6d&"
import script from "./importEleve.vue?vue&type=script&lang=js&"
export * from "./importEleve.vue?vue&type=script&lang=js&"
import style0 from "./importEleve.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports